import React, { Component, Fragment } from 'react'
import Select, { components } from 'react-select'

class SortDropdown extends Component {

  state = {
    optionSelected: {
      key: 1,
      icon: "sort numeric down",
      value: 1,
      name: "_score",
      direction: "desc",
      text: "Relevance ",
      label: "Relevance "
    }
  }

  _onChange = (props) => {
    this.props.changeSort(props.name, props.direction)
    this.setState({
      ...this.state,
      optionSelected: props
    })
  }

  sortData = [
    {
      key: 1,
      icon: "sort numeric down",
      value: 1,
      name: "_score",
      direction: "desc",
      text: "Relevance ",
      label: "Relevance "
    },
    {
      key: 3,
      icon: "sort amount down",
      value: 3,
      name: (this.props.app === 'ELSS' ? 'updated_at' : "yearstr"),
      direction: "desc",
      text: "Date",
      label: "Date"
    }
  ]

  addPrefix = option => (
    {
      ...option,
      label: `Sort By: ${option && option.label}`
    }
  )

  render() {
    return(
      <Fragment>
        <Select
          defaultValue={this.addPrefix(this.sortData.find(sd => sd.name === this.props.sortField) || this.sortData[0])}
          options={this.sortData}
          components={{ SingleValue }}
          isSearchable={false}
          isClearable={false}
          isMulti={false}
          onChange={this._onChange}
        />
      </Fragment>
    )
  }
}

const SingleValue = ({ children, ...props }) => {
  return (
  <components.SingleValue {...props}>
    { children }
  </components.SingleValue>
)}

export default SortDropdown